export const GET_ORDERS_REQUEST = "GET_ORDERS_REQUEST";
export const GET_ORDERS_SUCCESS = "GET_ORDERS_SUCCESS";
export const GET_ORDERS_FAILURE = "GET_ORDERS_FAILURE";

export const CONFIRMED_ORDER_SUCCESS = "CONFIRMED_ORDER_SUCCESS";
export const CONFIRMED_ORDER_REQUEST = "CONFIRMED_ORDER_REQUEST";
export const CONFIRMED_ORDER_FAILURE = "CONFIRMED_ORDER_FAILURE";

export const PLACED_ORDER_SUCCESS = "PLACED_ORDER_SUCCESS";
export const PLACED_ORDER_REQUEST = "PLACED_ORDER_REQUEST";
export const PLACED_ORDER_FAILURE = "PLACED_ORDER_FAILURE";

export const DELIVERED_ORDER_SUCCESS = "DELIVERED_ORDER_SUCCESS";
export const DELIVERED_ORDER_REQUEST = "DELIVERED_ORDER_REQUEST";
export const DELIVERED_ORDER_FAILURE = "DELIVERED_ORDER_FAILURE";

export const CANCELLED_ORDER_SUCCESS = "CANCELLED_ORDER_SUCCESS";
export const CANCELLED_ORDER_REQUEST = "CANCELLED_ORDER_REQUEST";
export const CANCELLED_ORDER_FAILURE = "CANCELLED_ORDER_FAILURE";

export const DELETE_ORDER_SUCCESS = "DELETE_ORDER_SUCCESS";
export const DELETE_ORDER_REQUEST = "DELETE_ORDER_REQUEST";
export const DELETE_ORDER_FAILURE = "DELETE_ORDER_FAILURE";

export const SHIP_ORDER_SUCCESS = "SHIP_ORDER_SUCCESS";
export const SHIP_ORDER_REQUEST = "SHIP_ORDER_REQUEST";
export const SHIP_ORDER_FAILURE = "SHIP_ORDER_FAILURE";

export const GET_ORDER_STATISTICS_REQUEST = "GET_ORDER_STATISTICS_REQUEST";
export const GET_ORDER_STATISTICS_SUCCESS = "GET_ORDER_STATISTICS_SUCCESS";
export const GET_ORDER_STATISTICS_FAILURE = "GET_ORDER_STATISTICS_FAILURE";
